import { AccountDetailsExplanation } from "@common/Layout/AccountDetailsExplanation";
import { AccountDetailsLayout } from "@common/Layout/AccountDetailsLayout";
import { SelectedServiceContext } from "@context/ISelectedContext";
import { Grid } from "@material-ui/core";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import moveMyNumber from "@static/img/portin/moveMyNumber.png";
import ScheduleTermination from "./ScheduleTermination";
import TerminationStatus from "./TerminationStatus";
import { HandleErrorAndLoading } from "@common/handleErrorAndLoading/HandleErrorAndLoading";
import { useTerminateNumber } from "@features/TerminateNumber/hook/useTerminateNumber";

const TerminateNumberPage = () => {
    const { selectedService } = useContext(SelectedServiceContext);
    const { t } = useTranslation(["sim", "accountDetails"]);
    const {
        terminateNumberDetails,
        getTerminateNumberDetailsStatus,
        postTerminationNumberStatus,
        postNumberTermination,
        postTerminationNumberCancellationStatus,
        postNumberTerminationCancellation,
    } = useTerminateNumber();

    return (
        <AccountDetailsLayout requireNumberSelection title={t("accountDetails:terminateMyNumber")}>
            <Grid container spacing={4}>
                {!selectedService && (
                    <Grid item xs={12}>
                        <AccountDetailsExplanation
                            alt="terminate subscription"
                            src={moveMyNumber}
                            texts={[
                                t("accountDetails:terminateStep1"),
                                t("accountDetails:terminateStep2"),
                                t("accountDetails:terminateStep3"),
                            ]}
                            title={t("accountDetails:sorryToSeeYouGo")}
                        />
                    </Grid>
                )}
                {selectedService && (
                    <HandleErrorAndLoading
                        error={getTerminateNumberDetailsStatus.error}
                        isLoading={getTerminateNumberDetailsStatus.isLoading}
                    >
                        {terminateNumberDetails && (
                            <>
                                {terminateNumberDetails.pending ? (
                                    <TerminationStatus
                                        date={terminateNumberDetails.date}
                                        postTerminationNumberCancellationStatus={
                                            postTerminationNumberCancellationStatus
                                        }
                                        postNumberTerminationCancellation={postNumberTerminationCancellation}
                                    />
                                ) : (
                                    <ScheduleTermination
                                        service={selectedService}
                                        postTerminationNumberStatus={postTerminationNumberStatus}
                                        postNumberTermination={postNumberTermination}
                                    />
                                )}
                            </>
                        )}
                    </HandleErrorAndLoading>
                )}
            </Grid>
        </AccountDetailsLayout>
    );
};

export default TerminateNumberPage;
